'use client';

import { Box, Button, Heading, Image, Flex, Stack } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { HoveringBox } from '~/components/ui/motion/Box';
import { useAgency } from '~/hooks/useAgency';
import { useFilters } from '~/hooks/useFilters';

interface Page404Props {
  title?: string;
}

export function Page404({
  title = 'Sidan hittades inte',
}: Page404Props) {
  const { push } = useRouter();
  const { getIllustrationsRoute, settings } = useAgency();
  const { getSearchRoute } = useFilters();
  const { utility } = settings || {};
  const { showIllustrations } = utility || {};

  return (
    <Flex minHeight="70vh" direction="column" justifyContent="center">
      {showIllustrations && (
        <HoveringBox>
          <Image
            src={getIllustrationsRoute('404.svg')}
            alt="Error 404 not found Illustration"
          />
        </HoveringBox>
      )}
      <Stack pb={30} gap="2">
        <Heading textAlign="center" size="lg">
          {title}
        </Heading>

        <Box textAlign="center" marginTop={4}>
          <Button
            variant="secondary"
            onClick={() => push(getSearchRoute())}
          >
            Gå tillbaka
          </Button>
        </Box>
      </Stack>
    </Flex>
  );
};
